<template>
  <div class="menu-facture-frais">
    <div class="list-tabs">
      <v-tabs
        bg-color="#704ad1"
        :hide-slider="false"
        slider-color="#704ad1"
        v-model="model"
      >
        <v-tab :href="`#tab-${0}`">
          <router-link
            to="/frais-th/simulation-facture-frais"
            class="font-tabs-facture"
          >
            Simulation facture
          </router-link>
        </v-tab>
        <v-tab :href="`#tab-${1}`">
          <router-link
            to="/frais-th/vision-globale-frais"
            class="font-tabs-facture"
          >
            Gestion global des frais
          </router-link>
        </v-tab>
      </v-tabs>
    </div>
    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      model: 0
    };
  },
  computed: {
    ...mapGetters([
      'checkPermission',
      'getShowNotifExportFile',
      'computedRouterLinkFacture'
    ])
  },
  watch: {
    $route(e) {
      if (this.computedRouterLinkFacture) {
        this.model = e.meta.tab;
      }
    }
  },
  mounted() {
    if (this.computedRouterLinkFacture) {
      this.model = this.$route.meta.tab;
    }
  }
};
</script>
<style scoped lang="scss">
.menu-facture-frais {
  position: absolute;
  top: 35px;
  right: 0;
  left: 0px;
  height: 30px;
  // z-index: 999;
  background: #fff;
  border-top: outset;
  .list-tabs {
    background-color: #f6f6f6;
    display: flex;
    align-items: center;
    .v-tabs {
      width: max-content;
    }
    .v-application .deep-purple {
      background-color: #704ad1 !important;
      border-color: #704ad1 !important;
      width: 100%;
    }
  }
}
.v-tab {
  &:hover {
    text-decoration: none;
    background-color: #f1edfb;
  }
}
.v-application {
  a {
    color: #2f2f2f !important;
    font-size: 11px;
    font-weight: 600;
    padding: 4px 5px;
    font-family: 'Montserrat', sans-serif;
    white-space: nowrap;
    // line-height: 42px;
    // padding: 9px 24px 9px 23px;
    text-align: center;
    text-transform: capitalize;
    &.router-link-exact-active {
      color: #704ad1 !important;
      font-size: 11px;
      font-weight: 600;
      font-family: 'Montserrat', sans-serif;
      white-space: nowrap;
      // line-height: 42px;
      &:hover {
        background-color: transparent;
      }
    }
    &:hover {
      text-decoration: none;
      background-color: #f1edfb;
    }
    &:focus {
    }
  }
}
.v-application--is-ltr
  .v-tabs--align-with-title
  > .v-tabs-bar:not(.v-tabs-bar--show-arrows):not(.v-slide-group--is-overflowing)
  > .v-slide-group__wrapper
  > .v-tabs-bar__content
  > .v-tab:first-child,
.v-application--is-ltr
  .v-tabs--align-with-title
  > .v-tabs-bar:not(.v-tabs-bar--show-arrows):not(.v-slide-group--is-overflowing)
  > .v-slide-group__wrapper
  > .v-tabs-bar__content
  > .v-tabs-slider-wrapper
  + .v-tab {
  margin-left: 0px;
  padding: 0px;
}
// .v-tabs-bar {
//   border-radius: inherit;
//   height: 30px;
// }
</style>
<style lang="scss"></style>
